const es = {
	Credentials: "Credenciais",
	Logout: "Terminar sessão",
	"My Credentials": "As minhas credenciais",
	"Issue Date": "Data de emissão",
	By: "Por",
	View: "Visualizar",
	Verify: "Verificar",
	purchase_for: "Comprar para",
	"Terms of Service": "Termos de Serviço",
	"Privacy & Data Protection": "Privacidade e Proteção de Dados",
	"Customer Support": "Apoio ao Cliente",
	"Help Center": "Centro de Ajuda",
	"Verify Certificate": "Verificar certificado",
	"View Certificate": "Visualizar certificado",
	Inbox: "Caixa de entrada",
	//to do
	"Open Issuers App": "Emittenten-App",
	Name: "Name",
	"You are purchasing": "Sie kaufen",
	"Payment info": "Zahlungsinformationen",
	Email: "Email",
};
export default es;
